export const sales = [
    {
      id: 10248,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Olivia Peyton",
      amount: 1740,
      date: new Date("2019-01-06")
    },
    {
      id: 10249,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Olivia Peyton",
      amount: 850,
      date: new Date("2019-01-13")
    },
    {
      id: 10250,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 2235,
      date: new Date("2019-01-07")
    },
    {
      id: 10251,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 1965,
      date: new Date("2019-01-03")
    },
    {
      id: 10252,
      salon: "Wilson",
      country: "Canada",
      stylist: "Brett Wade",
      amount: 880,
      date: new Date("2019-01-10")
    },
    {
      id: 10253,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Sandra Johnson",
      amount: 5260,
      date: new Date("2019-01-17")
    },
    {
      id: 10254,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Kevin Carter",
      amount: 2790,
      date: new Date("2019-01-21")
    },
    {
      id: 10255,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Cynthia Stanwick",
      amount: 3140,
      date: new Date("2019-01-01")
    },
    {
      id: 10256,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Kent Samuelson",
      amount: 6175,
      date: new Date("2019-01-24")
    },
    {
      id: 10257,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Taylor Riley",
      amount: 4575,
      date: new Date("2019-01-11")
    },
    {
      id: 10258,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Sam Hill",
      amount: 3680,
      date: new Date("2019-01-12")
    },
    {
      id: 10259,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Kelly Rodriquez",
      amount: 2260,
      date: new Date("2019-01-01")
    },
    {
      id: 10260,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Walter Hobbs",
      amount: 2910,
      date: new Date("2019-01-26")
    },
    {
      id: 10261,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 8400,
      date: new Date("2019-01-05")
    },
    {
      id: 10262,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 1325,
      date: new Date("2019-01-14")
    },
    {
      id: 10263,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 3920,
      date: new Date("2019-01-05")
    },
    {
      id: 10264,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 2220,
      date: new Date("2019-01-15")
    },
    {
      id: 10265,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 940,
      date: new Date("2019-01-01")
    },
    {
      id: 10266,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1630,
      date: new Date("2019-01-10")
    },
    {
      id: 10267,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 2910,
      date: new Date("2019-01-23")
    },
    {
      id: 10268,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 2600,
      date: new Date("2019-01-14")
    },
    {
      id: 10269,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 4340,
      date: new Date("2019-01-26")
    },
    {
      id: 10270,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 6650,
      date: new Date("2019-01-24")
    },
    {
      id: 10271,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 490,
      date: new Date("2019-01-22")
    },
    {
      id: 10272,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 3390,
      date: new Date("2019-01-25")
    },
    {
      id: 10273,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 5160,
      date: new Date("2019-02-20")
    },
    {
      id: 10274,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 5750,
      date: new Date("2019-02-12")
    },
    {
      id: 10275,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 2805,
      date: new Date("2019-02-13")
    },
    {
      id: 10276,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 2505,
      date: new Date("2019-02-09")
    },
    {
      id: 10277,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 930,
      date: new Date("2019-02-04")
    },
    {
      id: 10278,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 1240,
      date: new Date("2019-02-03")
    },
    {
      id: 10279,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 315,
      date: new Date("2019-02-04")
    },
    {
      id: 10280,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 2870,
      date: new Date("2019-02-18")
    },
    {
      id: 10281,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 5150,
      date: new Date("2019-02-18")
    },
    {
      id: 10282,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 2725,
      date: new Date("2019-02-20")
    },
    {
      id: 10283,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 2840,
      date: new Date("2019-02-04")
    },
    {
      id: 10284,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "",
      amount: 5840,
      date: new Date("2019-02-13")
    },
    {
      id: 10285,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 6750,
      date: new Date("2019-02-11")
    },
    {
      id: 10286,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 1200,
      date: new Date("2019-02-03")
    },
    {
      id: 10287,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 4550,
      date: new Date("2019-02-08")
    },
    {
      id: 10288,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 6040,
      date: new Date("2019-02-17")
    },
    {
      id: 10289,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 2205,
      date: new Date("2019-02-08")
    },
    {
      id: 10290,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 990,
      date: new Date("2019-02-20")
    },
    {
      id: 10291,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 700,
      date: new Date("2019-02-11")
    },
    {
      id: 10292,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 2325,
      date: new Date("2019-02-15")
    },
    {
      id: 10293,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 930,
      date: new Date("2019-02-21")
    },
    {
      id: 10294,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 1560,
      date: new Date("2019-02-04")
    },
    {
      id: 10295,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 1740,
      date: new Date("2019-03-04")
    },
    {
      id: 10296,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 3575,
      date: new Date("2019-03-20")
    },
    {
      id: 10297,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 4500,
      date: new Date("2019-03-04")
    },
    {
      id: 10298,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 1605,
      date: new Date("2019-03-17")
    },
    {
      id: 10299,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 800,
      date: new Date("2019-03-21")
    },
    {
      id: 10300,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 640,
      date: new Date("2019-03-08")
    },
    {
      id: 10301,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 735,
      date: new Date("2019-03-19")
    },
    {
      id: 10302,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 2520,
      date: new Date("2019-03-20")
    },
    {
      id: 10303,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 6675,
      date: new Date("2019-03-18")
    },
    {
      id: 10304,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 3625,
      date: new Date("2019-03-25")
    },
    {
      id: 10305,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 1200,
      date: new Date("2019-03-07")
    },
    {
      id: 10306,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 2000,
      date: new Date("2019-03-07")
    },
    {
      id: 10307,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 1410,
      date: new Date("2019-03-10")
    },
    {
      id: 10308,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 2700,
      date: new Date("2019-03-19")
    },
    {
      id: 10309,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 5950,
      date: new Date("2019-03-24")
    },
    {
      id: 10310,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 5120,
      date: new Date("2019-03-08")
    },
    {
      id: 10311,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 1980,
      date: new Date("2019-03-17")
    },
    {
      id: 10312,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 1110,
      date: new Date("2019-03-08")
    },
    {
      id: 10313,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 980,
      date: new Date("2019-03-21")
    },
    {
      id: 10314,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 5460,
      date: new Date("2019-03-19")
    },
    {
      id: 10315,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 3800,
      date: new Date("2019-03-12")
    },
    {
      id: 10316,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 2610,
      date: new Date("2019-03-04")
    },
    {
      id: 10317,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 3080,
      date: new Date("2019-03-22")
    },
    {
      id: 10318,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 2010,
      date: new Date("2019-03-23")
    },
    {
      id: 10319,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 1200,
      date: new Date("2019-03-04")
    },
    {
      id: 10320,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 7680,
      date: new Date("2019-04-15")
    },
    {
      id: 10321,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 1325,
      date: new Date("2019-04-07")
    },
    {
      id: 10322,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 2835,
      date: new Date("2019-04-10")
    },
    {
      id: 10323,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 3660,
      date: new Date("2019-04-10")
    },
    {
      id: 10324,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 390,
      date: new Date("2019-04-12")
    },
    {
      id: 10325,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 4420,
      date: new Date("2019-04-08")
    },
    {
      id: 10326,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 1755,
      date: new Date("2019-04-13")
    },
    {
      id: 10327,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 2580,
      date: new Date("2019-04-15")
    },
    {
      id: 10328,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 850,
      date: new Date("2019-04-01")
    },
    {
      id: 10329,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 2825,
      date: new Date("2019-04-10")
    },
    {
      id: 10330,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 540,
      date: new Date("2019-04-06")
    },
    {
      id: 10331,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 1520,
      date: new Date("2019-04-08")
    },
    {
      id: 10332,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 8760,
      date: new Date("2019-04-26")
    },
    {
      id: 10333,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 1110,
      date: new Date("2019-04-16")
    },
    {
      id: 10334,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 6850,
      date: new Date("2019-04-19")
    },
    {
      id: 10335,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 1940,
      date: new Date("2019-04-23")
    },
    {
      id: 10336,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 1980,
      date: new Date("2019-04-21")
    },
    {
      id: 10337,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 3090,
      date: new Date("2019-04-03")
    },
    {
      id: 10338,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1640,
      date: new Date("2019-04-24")
    },
    {
      id: 10339,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 3585,
      date: new Date("2019-04-01")
    },
    {
      id: 10340,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 1770,
      date: new Date("2019-04-01")
    },
    {
      id: 10341,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 4005,
      date: new Date("2019-04-04")
    },
    {
      id: 10342,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 2870,
      date: new Date("2019-04-02")
    },
    {
      id: 10343,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 960,
      date: new Date("2019-04-20")
    },
    {
      id: 10344,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 8640,
      date: new Date("2019-05-14")
    },
    {
      id: 10345,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 5450,
      date: new Date("2019-05-24")
    },
    {
      id: 10346,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 2535,
      date: new Date("2019-05-07")
    },
    {
      id: 10347,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 1155,
      date: new Date("2019-05-20")
    },
    {
      id: 10348,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 3140,
      date: new Date("2019-05-18")
    },
    {
      id: 10349,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 2260,
      date: new Date("2019-05-19")
    },
    {
      id: 10350,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 1215,
      date: new Date("2019-05-23")
    },
    {
      id: 10351,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 1210,
      date: new Date("2019-05-08")
    },
    {
      id: 10352,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 875,
      date: new Date("2019-05-25")
    },
    {
      id: 10353,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 5400,
      date: new Date("2019-05-03")
    },
    {
      id: 10354,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 5940,
      date: new Date("2019-05-25")
    },
    {
      id: 10355,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 4700,
      date: new Date("2019-05-03")
    },
    {
      id: 10356,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 5520,
      date: new Date("2019-05-12")
    },
    {
      id: 10357,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 9210,
      date: new Date("2019-05-22")
    },
    {
      id: 10358,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 7950,
      date: new Date("2019-05-12")
    },
    {
      id: 10359,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 3740,
      date: new Date("2019-05-24")
    },
    {
      id: 10360,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 990,
      date: new Date("2019-05-02")
    },
    {
      id: 10361,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 3190,
      date: new Date("2019-05-03")
    },
    {
      id: 10362,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 2430,
      date: new Date("2019-05-11")
    },
    {
      id: 10363,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 7380,
      date: new Date("2019-06-15")
    },
    {
      id: 10364,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 4475,
      date: new Date("2019-06-08")
    },
    {
      id: 10365,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 1290,
      date: new Date("2019-06-10")
    },
    {
      id: 10366,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 2250,
      date: new Date("2019-06-10")
    },
    {
      id: 10367,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 350,
      date: new Date("2019-06-22")
    },
    {
      id: 10368,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 5480,
      date: new Date("2019-06-24")
    },
    {
      id: 10369,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 2355,
      date: new Date("2019-06-10")
    },
    {
      id: 10370,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 1960,
      date: new Date("2019-06-23")
    },
    {
      id: 10371,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 4125,
      date: new Date("2019-06-06")
    },
    {
      id: 10372,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 7925,
      date: new Date("2019-06-12")
    },
    {
      id: 10373,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 1120,
      date: new Date("2019-06-22")
    },
    {
      id: 10374,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 5100,
      date: new Date("2019-06-01")
    },
    {
      id: 10375,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 1500,
      date: new Date("2019-06-25")
    },
    {
      id: 10376,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 5130,
      date: new Date("2019-06-10")
    },
    {
      id: 10377,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 2475,
      date: new Date("2019-06-10")
    },
    {
      id: 10378,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 2100,
      date: new Date("2019-06-06")
    },
    {
      id: 10379,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 3570,
      date: new Date("2019-06-10")
    },
    {
      id: 10380,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 550,
      date: new Date("2019-06-02")
    },
    {
      id: 10381,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 2850,
      date: new Date("2019-06-26")
    },
    {
      id: 10382,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 4280,
      date: new Date("2019-06-19")
    },
    {
      id: 10383,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 1460,
      date: new Date("2019-06-17")
    },
    {
      id: 10384,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 960,
      date: new Date("2019-06-17")
    },
    {
      id: 10385,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1520,
      date: new Date("2019-06-03")
    },
    {
      id: 10386,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 6750,
      date: new Date("2019-06-21")
    },
    {
      id: 10387,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 7260,
      date: new Date("2019-07-14")
    },
    {
      id: 10388,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 2450,
      date: new Date("2019-07-11")
    },
    {
      id: 10389,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 3540,
      date: new Date("2019-07-02")
    },
    {
      id: 10390,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 1950,
      date: new Date("2019-07-03")
    },
    {
      id: 10391,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 360,
      date: new Date("2019-07-07")
    },
    {
      id: 10392,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 4500,
      date: new Date("2019-07-03")
    },
    {
      id: 10393,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 4575,
      date: new Date("2019-07-21")
    },
    {
      id: 10394,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 2310,
      date: new Date("2019-07-18")
    },
    {
      id: 10395,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 7500,
      date: new Date("2019-07-04")
    },
    {
      id: 10396,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 3575,
      date: new Date("2019-07-23")
    },
    {
      id: 10397,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 760,
      date: new Date("2019-07-01")
    },
    {
      id: 10398,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 2400,
      date: new Date("2019-07-11")
    },
    {
      id: 10399,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 3330,
      date: new Date("2019-07-04")
    },
    {
      id: 10400,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 3480,
      date: new Date("2019-07-23")
    },
    {
      id: 10401,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 4875,
      date: new Date("2019-07-11")
    },
    {
      id: 10402,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 4980,
      date: new Date("2019-07-19")
    },
    {
      id: 10403,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 2580,
      date: new Date("2019-07-04")
    },
    {
      id: 10404,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 2650,
      date: new Date("2019-07-16")
    },
    {
      id: 10405,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1190,
      date: new Date("2019-07-02")
    },
    {
      id: 10406,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 960,
      date: new Date("2019-07-26")
    },
    {
      id: 10407,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 3600,
      date: new Date("2019-08-08")
    },
    {
      id: 10408,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 2250,
      date: new Date("2019-08-01")
    },
    {
      id: 10409,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 1275,
      date: new Date("2019-08-02")
    },
    {
      id: 10410,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 3885,
      date: new Date("2019-08-14")
    },
    {
      id: 10411,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 1900,
      date: new Date("2019-08-05")
    },
    {
      id: 10412,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 2300,
      date: new Date("2019-08-09")
    },
    {
      id: 10413,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 2895,
      date: new Date("2019-08-15")
    },
    {
      id: 10414,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 350,
      date: new Date("2019-08-20")
    },
    {
      id: 10415,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 4200,
      date: new Date("2019-08-22")
    },
    {
      id: 10416,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 7175,
      date: new Date("2019-08-14")
    },
    {
      id: 10417,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 4420,
      date: new Date("2019-08-24")
    },
    {
      id: 10418,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 5200,
      date: new Date("2019-08-21")
    },
    {
      id: 10419,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 7920,
      date: new Date("2019-08-17")
    },
    {
      id: 10420,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 6990,
      date: new Date("2019-08-22")
    },
    {
      id: 10421,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 2125,
      date: new Date("2019-08-05")
    },
    {
      id: 10422,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 2220,
      date: new Date("2019-08-16")
    },
    {
      id: 10423,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 1575,
      date: new Date("2019-08-23")
    },
    {
      id: 10424,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 1880,
      date: new Date("2019-08-12")
    },
    {
      id: 10425,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 710,
      date: new Date("2019-08-25")
    },
    {
      id: 10426,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 390,
      date: new Date("2019-08-20")
    },
    {
      id: 10427,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 4635,
      date: new Date("2019-08-04")
    },
    {
      id: 10428,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 4350,
      date: new Date("2019-08-19")
    },
    {
      id: 10429,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 6020,
      date: new Date("2019-08-02")
    },
    {
      id: 10430,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 3660,
      date: new Date("2019-08-19")
    },
    {
      id: 10431,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 4525,
      date: new Date("2019-08-24")
    },
    {
      id: 10432,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 4410,
      date: new Date("2019-09-12")
    },
    {
      id: 10433,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 1725,
      date: new Date("2019-09-07")
    },
    {
      id: 10434,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 2715,
      date: new Date("2019-09-14")
    },
    {
      id: 10435,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 2820,
      date: new Date("2019-09-08")
    },
    {
      id: 10436,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 2310,
      date: new Date("2019-09-12")
    },
    {
      id: 10437,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 780,
      date: new Date("2019-09-08")
    },
    {
      id: 10438,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 2370,
      date: new Date("2019-09-19")
    },
    {
      id: 10439,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 1410,
      date: new Date("2019-09-09")
    },
    {
      id: 10440,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 1825,
      date: new Date("2019-09-23")
    },
    {
      id: 10441,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 4075,
      date: new Date("2019-09-06")
    },
    {
      id: 10442,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 1020,
      date: new Date("2019-09-04")
    },
    {
      id: 10443,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 4320,
      date: new Date("2019-09-25")
    },
    {
      id: 10444,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 7530,
      date: new Date("2019-09-13")
    },
    {
      id: 10445,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 2820,
      date: new Date("2019-09-08")
    },
    {
      id: 10446,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 3050,
      date: new Date("2019-09-04")
    },
    {
      id: 10447,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 5080,
      date: new Date("2019-09-25")
    },
    {
      id: 10448,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 1125,
      date: new Date("2019-09-13")
    },
    {
      id: 10449,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 850,
      date: new Date("2019-09-24")
    },
    {
      id: 10450,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1440,
      date: new Date("2019-09-19")
    },
    {
      id: 10451,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 1950,
      date: new Date("2019-09-02")
    },
    {
      id: 10452,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 6390,
      date: new Date("2019-10-11")
    },
    {
      id: 10453,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 4625,
      date: new Date("2019-10-02")
    },
    {
      id: 10454,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 3510,
      date: new Date("2019-10-24")
    },
    {
      id: 10455,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 2730,
      date: new Date("2019-10-15")
    },
    {
      id: 10456,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 2070,
      date: new Date("2019-10-15")
    },
    {
      id: 10457,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 2320,
      date: new Date("2019-10-18")
    },
    {
      id: 10458,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 4260,
      date: new Date("2019-10-24")
    },
    {
      id: 10459,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 840,
      date: new Date("2019-10-18")
    },
    {
      id: 10460,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 7300,
      date: new Date("2019-10-24")
    },
    {
      id: 10461,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 5950,
      date: new Date("2019-10-11")
    },
    {
      id: 10462,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 3220,
      date: new Date("2019-10-25")
    },
    {
      id: 10463,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 3480,
      date: new Date("2019-10-08")
    },
    {
      id: 10464,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 4830,
      date: new Date("2019-10-26")
    },
    {
      id: 10465,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 4470,
      date: new Date("2019-10-05")
    },
    {
      id: 10466,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 3675,
      date: new Date("2019-10-23")
    },
    {
      id: 10467,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 4260,
      date: new Date("2019-10-01")
    },
    {
      id: 10468,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 4245,
      date: new Date("2019-10-26")
    },
    {
      id: 10469,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 1470,
      date: new Date("2019-10-01")
    },
    {
      id: 10470,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1810,
      date: new Date("2019-10-02")
    },
    {
      id: 10471,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 600,
      date: new Date("2019-10-23")
    },
    {
      id: 10472,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 7500,
      date: new Date("2019-11-03")
    },
    {
      id: 10473,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 4625,
      date: new Date("2019-11-02")
    },
    {
      id: 10474,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 2625,
      date: new Date("2019-11-09")
    },
    {
      id: 10475,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 1440,
      date: new Date("2019-11-15")
    },
    {
      id: 10476,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 2420,
      date: new Date("2019-11-15")
    },
    {
      id: 10477,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 4180,
      date: new Date("2019-11-15")
    },
    {
      id: 10478,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 3720,
      date: new Date("2019-11-25")
    },
    {
      id: 10479,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 2730,
      date: new Date("2019-11-08")
    },
    {
      id: 10480,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 3775,
      date: new Date("2019-11-17")
    },
    {
      id: 10481,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 3525,
      date: new Date("2019-11-15")
    },
    {
      id: 10482,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 5320,
      date: new Date("2019-11-08")
    },
    {
      id: 10483,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 5340,
      date: new Date("2019-11-13")
    },
    {
      id: 10484,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 8850,
      date: new Date("2019-11-01")
    },
    {
      id: 10485,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 7050,
      date: new Date("2019-11-14")
    },
    {
      id: 10486,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 4200,
      date: new Date("2019-11-18")
    },
    {
      id: 10487,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 4960,
      date: new Date("2019-11-04")
    },
    {
      id: 10488,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 2280,
      date: new Date("2019-11-13")
    },
    {
      id: 10489,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 590,
      date: new Date("2019-11-11")
    },
    {
      id: 10490,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 810,
      date: new Date("2019-11-12")
    },
    {
      id: 10491,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 2625,
      date: new Date("2019-11-07")
    },
    {
      id: 10492,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 8280,
      date: new Date("2019-12-01")
    },
    {
      id: 10493,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 5650,
      date: new Date("2019-12-19")
    },
    {
      id: 10494,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 2760,
      date: new Date("2019-12-14")
    },
    {
      id: 10495,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 2670,
      date: new Date("2019-12-03")
    },
    {
      id: 10496,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 2520,
      date: new Date("2019-12-20")
    },
    {
      id: 10497,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 4080,
      date: new Date("2019-12-21")
    },
    {
      id: 10498,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 4140,
      date: new Date("2019-12-22")
    },
    {
      id: 10499,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 390,
      date: new Date("2019-12-04")
    },
    {
      id: 10500,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 1400,
      date: new Date("2019-12-19")
    },
    {
      id: 10501,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 7275,
      date: new Date("2019-12-22")
    },
    {
      id: 10502,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 4100,
      date: new Date("2019-12-20")
    },
    {
      id: 10503,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 5520,
      date: new Date("2019-12-25")
    },
    {
      id: 10504,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 9210,
      date: new Date("2019-12-24")
    },
    {
      id: 10505,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 7290,
      date: new Date("2019-12-05")
    },
    {
      id: 10506,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 625,
      date: new Date("2019-12-22")
    },
    {
      id: 10507,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 4460,
      date: new Date("2019-12-12")
    },
    {
      id: 10508,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 3825,
      date: new Date("2019-12-13")
    },
    {
      id: 10509,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 2850,
      date: new Date("2019-12-17")
    },
    {
      id: 10510,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 2780,
      date: new Date("2019-12-07")
    },
    {
      id: 10511,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 840,
      date: new Date("2019-12-18")
    },
    {
      id: 10512,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 2970,
      date: new Date("2019-12-23")
    },
    {
      id: 10513,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 945,
      date: new Date("2019-12-06")
    },
    {
      id: 10514,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 2625,
      date: new Date("2019-12-04")
    },
    {
      id: 10515,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 390,
      date: new Date("2019-12-01")
    },
    {
      id: 10516,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 2250,
      date: new Date("2019-12-02")
    },
    {
      id: 10517,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 7710,
      date: new Date("2020-01-18")
    },
    {
      id: 10518,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 7975,
      date: new Date("2020-01-10")
    },
    {
      id: 10519,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 3285,
      date: new Date("2020-01-13")
    },
    {
      id: 10520,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 2580,
      date: new Date("2020-01-22")
    },
    {
      id: 10521,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 2160,
      date: new Date("2020-01-26")
    },
    {
      id: 10522,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 1100,
      date: new Date("2020-01-25")
    },
    {
      id: 10523,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 4425,
      date: new Date("2020-01-21")
    },
    {
      id: 10524,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 1360,
      date: new Date("2020-01-22")
    },
    {
      id: 10525,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 3250,
      date: new Date("2020-01-14")
    },
    {
      id: 10526,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 5550,
      date: new Date("2020-01-21")
    },
    {
      id: 10527,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 2860,
      date: new Date("2020-01-25")
    },
    {
      id: 10528,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 5320,
      date: new Date("2020-01-08")
    },
    {
      id: 10529,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 4050,
      date: new Date("2020-01-14")
    },
    {
      id: 10530,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 3450,
      date: new Date("2020-01-24")
    },
    {
      id: 10531,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 5425,
      date: new Date("2020-01-11")
    },
    {
      id: 10532,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 4860,
      date: new Date("2020-01-12")
    },
    {
      id: 10533,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 4695,
      date: new Date("2020-01-16")
    },
    {
      id: 10534,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 610,
      date: new Date("2020-01-05")
    },
    {
      id: 10535,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1580,
      date: new Date("2020-01-15")
    },
    {
      id: 10536,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 3780,
      date: new Date("2020-02-18")
    },
    {
      id: 10537,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 5400,
      date: new Date("2020-02-21")
    },
    {
      id: 10538,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 630,
      date: new Date("2020-02-18")
    },
    {
      id: 10539,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 3960,
      date: new Date("2020-02-04")
    },
    {
      id: 10540,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 2010,
      date: new Date("2020-02-25")
    },
    {
      id: 10541,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 5000,
      date: new Date("2020-02-01")
    },
    {
      id: 10542,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 1995,
      date: new Date("2020-02-20")
    },
    {
      id: 10543,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 860,
      date: new Date("2020-02-12")
    },
    {
      id: 10544,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 2150,
      date: new Date("2020-02-10")
    },
    {
      id: 10545,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 4050,
      date: new Date("2020-02-06")
    },
    {
      id: 10546,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 2960,
      date: new Date("2020-02-18")
    },
    {
      id: 10547,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 1780,
      date: new Date("2020-02-26")
    },
    {
      id: 10548,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 8700,
      date: new Date("2020-02-03")
    },
    {
      id: 10549,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 3390,
      date: new Date("2020-02-03")
    },
    {
      id: 10550,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 4425,
      date: new Date("2020-02-15")
    },
    {
      id: 10551,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 1180,
      date: new Date("2020-02-23")
    },
    {
      id: 10552,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 360,
      date: new Date("2020-02-08")
    },
    {
      id: 10553,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 2310,
      date: new Date("2020-02-13")
    },
    {
      id: 10554,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1770,
      date: new Date("2020-02-20")
    },
    {
      id: 10555,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 3060,
      date: new Date("2020-02-26")
    },
    {
      id: 10556,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 1750,
      date: new Date("2020-02-12")
    },
    {
      id: 10557,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 2280,
      date: new Date("2020-03-09")
    },
    {
      id: 10558,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 7600,
      date: new Date("2020-03-25")
    },
    {
      id: 10559,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 1035,
      date: new Date("2020-03-23")
    },
    {
      id: 10560,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 1245,
      date: new Date("2020-03-01")
    },
    {
      id: 10561,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 2860,
      date: new Date("2020-03-19")
    },
    {
      id: 10562,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 440,
      date: new Date("2020-03-19")
    },
    {
      id: 10563,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 4665,
      date: new Date("2020-03-02")
    },
    {
      id: 10564,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 2270,
      date: new Date("2020-03-15")
    },
    {
      id: 10565,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 5000,
      date: new Date("2020-03-09")
    },
    {
      id: 10566,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 5100,
      date: new Date("2020-03-23")
    },
    {
      id: 10567,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 2120,
      date: new Date("2020-03-11")
    },
    {
      id: 10568,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 5140,
      date: new Date("2020-03-05")
    },
    {
      id: 10569,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 6210,
      date: new Date("2020-03-19")
    },
    {
      id: 10570,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 9510,
      date: new Date("2020-03-19")
    },
    {
      id: 10571,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 7600,
      date: new Date("2020-03-21")
    },
    {
      id: 10572,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 5420,
      date: new Date("2020-03-15")
    },
    {
      id: 10573,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 1980,
      date: new Date("2020-03-05")
    },
    {
      id: 10574,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 1820,
      date: new Date("2020-03-07")
    },
    {
      id: 10575,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1670,
      date: new Date("2020-03-21")
    },
    {
      id: 10576,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 4800,
      date: new Date("2020-03-08")
    },
    {
      id: 10577,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 2925,
      date: new Date("2020-03-03")
    },
    {
      id: 10578,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 2940,
      date: new Date("2020-04-11")
    },
    {
      id: 10579,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 3525,
      date: new Date("2020-04-13")
    },
    {
      id: 10580,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 2475,
      date: new Date("2020-04-22")
    },
    {
      id: 10581,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 3315,
      date: new Date("2020-04-08")
    },
    {
      id: 10582,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 3140,
      date: new Date("2020-04-07")
    },
    {
      id: 10583,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 2520,
      date: new Date("2020-04-01")
    },
    {
      id: 10584,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 1200,
      date: new Date("2020-04-10")
    },
    {
      id: 10585,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 2060,
      date: new Date("2020-04-21")
    },
    {
      id: 10586,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 7875,
      date: new Date("2020-04-02")
    },
    {
      id: 10587,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 1450,
      date: new Date("2020-04-07")
    },
    {
      id: 10588,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 2640,
      date: new Date("2020-04-22")
    },
    {
      id: 10589,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 1960,
      date: new Date("2020-04-16")
    },
    {
      id: 10590,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 2250,
      date: new Date("2020-04-23")
    },
    {
      id: 10591,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 4500,
      date: new Date("2020-04-05")
    },
    {
      id: 10592,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 5050,
      date: new Date("2020-04-11")
    },
    {
      id: 10593,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 2940,
      date: new Date("2020-04-02")
    },
    {
      id: 10594,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 2880,
      date: new Date("2020-04-14")
    },
    {
      id: 10595,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 1050,
      date: new Date("2020-04-19")
    },
    {
      id: 10596,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1850,
      date: new Date("2020-04-02")
    },
    {
      id: 10597,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 3160,
      date: new Date("2020-04-01")
    },
    {
      id: 10598,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 875,
      date: new Date("2020-04-04")
    },
    {
      id: 10599,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 3200,
      date: new Date("2020-04-08")
    },
    {
      id: 10600,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 1380,
      date: new Date("2020-04-21")
    },
    {
      id: 10601,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 3060,
      date: new Date("2020-04-06")
    },
    {
      id: 10602,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 6690,
      date: new Date("2020-05-19")
    },
    {
      id: 10603,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 4525,
      date: new Date("2020-05-15")
    },
    {
      id: 10604,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 4665,
      date: new Date("2020-05-10")
    },
    {
      id: 10605,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 4530,
      date: new Date("2020-05-18")
    },
    {
      id: 10606,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 1330,
      date: new Date("2020-05-08")
    },
    {
      id: 10607,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 1720,
      date: new Date("2020-05-20")
    },
    {
      id: 10608,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 3750,
      date: new Date("2020-05-16")
    },
    {
      id: 10609,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 1290,
      date: new Date("2020-05-10")
    },
    {
      id: 10610,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 4925,
      date: new Date("2020-05-14")
    },
    {
      id: 10611,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 4300,
      date: new Date("2020-05-22")
    },
    {
      id: 10612,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 5740,
      date: new Date("2020-05-08")
    },
    {
      id: 10613,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 3760,
      date: new Date("2020-05-18")
    },
    {
      id: 10614,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 7920,
      date: new Date("2020-05-22")
    },
    {
      id: 10615,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 1440,
      date: new Date("2020-05-21")
    },
    {
      id: 10616,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 5975,
      date: new Date("2020-05-25")
    },
    {
      id: 10617,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 4440,
      date: new Date("2020-05-05")
    },
    {
      id: 10618,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 2310,
      date: new Date("2020-05-24")
    },
    {
      id: 10619,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 2250,
      date: new Date("2020-05-06")
    },
    {
      id: 10620,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 2320,
      date: new Date("2020-05-14")
    },
    {
      id: 10621,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 8370,
      date: new Date("2020-05-06")
    },
    {
      id: 10622,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 5190,
      date: new Date("2020-06-26")
    },
    {
      id: 10623,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 925,
      date: new Date("2020-06-04")
    },
    {
      id: 10624,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 3240,
      date: new Date("2020-06-20")
    },
    {
      id: 10625,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 3180,
      date: new Date("2020-06-23")
    },
    {
      id: 10626,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 780,
      date: new Date("2020-06-13")
    },
    {
      id: 10627,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 4680,
      date: new Date("2020-06-08")
    },
    {
      id: 10628,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 2475,
      date: new Date("2020-06-25")
    },
    {
      id: 10629,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 1920,
      date: new Date("2020-06-20")
    },
    {
      id: 10630,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 7500,
      date: new Date("2020-06-25")
    },
    {
      id: 10631,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 5025,
      date: new Date("2020-06-26")
    },
    {
      id: 10632,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 2400,
      date: new Date("2020-06-08")
    },
    {
      id: 10633,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 1720,
      date: new Date("2020-06-09")
    },
    {
      id: 10634,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 2880,
      date: new Date("2020-06-21")
    },
    {
      id: 10635,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 5430,
      date: new Date("2020-06-03")
    },
    {
      id: 10636,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 4475,
      date: new Date("2020-06-19")
    },
    {
      id: 10637,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 1420,
      date: new Date("2020-06-20")
    },
    {
      id: 10638,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 2670,
      date: new Date("2020-06-25")
    },
    {
      id: 10639,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 1930,
      date: new Date("2020-06-02")
    },
    {
      id: 10640,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 580,
      date: new Date("2020-06-25")
    },
    {
      id: 10641,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1620,
      date: new Date("2020-06-12")
    },
    {
      id: 10642,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 4530,
      date: new Date("2020-06-02")
    },
    {
      id: 10643,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 6025,
      date: new Date("2020-06-23")
    },
    {
      id: 10644,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 3540,
      date: new Date("2020-07-21")
    },
    {
      id: 10645,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 3000,
      date: new Date("2020-07-01")
    },
    {
      id: 10646,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 3240,
      date: new Date("2020-07-26")
    },
    {
      id: 10647,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 2265,
      date: new Date("2020-07-22")
    },
    {
      id: 10648,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 400,
      date: new Date("2020-07-09")
    },
    {
      id: 10649,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 1460,
      date: new Date("2020-07-08")
    },
    {
      id: 10650,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 1620,
      date: new Date("2020-07-18")
    },
    {
      id: 10651,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 2400,
      date: new Date("2020-07-25")
    },
    {
      id: 10652,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 5275,
      date: new Date("2020-07-04")
    },
    {
      id: 10653,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 4475,
      date: new Date("2020-07-03")
    },
    {
      id: 10654,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 3980,
      date: new Date("2020-07-21")
    },
    {
      id: 10655,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 5240,
      date: new Date("2020-07-11")
    },
    {
      id: 10656,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 1200,
      date: new Date("2020-07-21")
    },
    {
      id: 10657,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 5700,
      date: new Date("2020-07-18")
    },
    {
      id: 10658,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 5575,
      date: new Date("2020-07-01")
    },
    {
      id: 10659,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 2160,
      date: new Date("2020-07-02")
    },
    {
      id: 10660,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 960,
      date: new Date("2020-07-09")
    },
    {
      id: 10661,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 1280,
      date: new Date("2020-07-04")
    },
    {
      id: 10662,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1040,
      date: new Date("2020-07-02")
    },
    {
      id: 10663,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 5520,
      date: new Date("2020-07-21")
    },
    {
      id: 10664,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 1760,
      date: new Date("2020-07-25")
    },
    {
      id: 10665,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 4080,
      date: new Date("2020-07-07")
    },
    {
      id: 10666,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1000,
      date: new Date("2020-07-21")
    },
    {
      id: 10667,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 3270,
      date: new Date("2020-07-12")
    },
    {
      id: 10668,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 1770,
      date: new Date("2020-08-23")
    },
    {
      id: 10669,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 2700,
      date: new Date("2020-08-09")
    },
    {
      id: 10670,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 2175,
      date: new Date("2020-08-03")
    },
    {
      id: 10671,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 3375,
      date: new Date("2020-08-11")
    },
    {
      id: 10672,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 2040,
      date: new Date("2020-08-01")
    },
    {
      id: 10673,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 3000,
      date: new Date("2020-08-21")
    },
    {
      id: 10674,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 3900,
      date: new Date("2020-08-16")
    },
    {
      id: 10675,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 1370,
      date: new Date("2020-08-20")
    },
    {
      id: 10676,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 5700,
      date: new Date("2020-08-01")
    },
    {
      id: 10677,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 1275,
      date: new Date("2020-08-22")
    },
    {
      id: 10678,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 4060,
      date: new Date("2020-08-13")
    },
    {
      id: 10679,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 2320,
      date: new Date("2020-08-18")
    },
    {
      id: 10680,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 7590,
      date: new Date("2020-08-24")
    },
    {
      id: 10681,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 4560,
      date: new Date("2020-08-20")
    },
    {
      id: 10682,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 7575,
      date: new Date("2020-08-20")
    },
    {
      id: 10683,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 700,
      date: new Date("2020-08-25")
    },
    {
      id: 10684,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 2400,
      date: new Date("2020-08-16")
    },
    {
      id: 10685,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 1390,
      date: new Date("2020-08-15")
    },
    {
      id: 10686,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1320,
      date: new Date("2020-08-09")
    },
    {
      id: 10687,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 1680,
      date: new Date("2020-08-09")
    },
    {
      id: 10688,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 1500,
      date: new Date("2020-08-11")
    },
    {
      id: 10689,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 6150,
      date: new Date("2020-09-21")
    },
    {
      id: 10690,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 3675,
      date: new Date("2020-09-02")
    },
    {
      id: 10691,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 2250,
      date: new Date("2020-09-05")
    },
    {
      id: 10692,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 3585,
      date: new Date("2020-09-10")
    },
    {
      id: 10693,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 1470,
      date: new Date("2020-09-01")
    },
    {
      id: 10694,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 2260,
      date: new Date("2020-09-02")
    },
    {
      id: 10695,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 3765,
      date: new Date("2020-09-03")
    },
    {
      id: 10696,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 1640,
      date: new Date("2020-09-04")
    },
    {
      id: 10697,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 4475,
      date: new Date("2020-09-09")
    },
    {
      id: 10698,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 5975,
      date: new Date("2020-09-04")
    },
    {
      id: 10699,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 1100,
      date: new Date("2020-09-16")
    },
    {
      id: 10700,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 1320,
      date: new Date("2020-09-18")
    },
    {
      id: 10701,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 8610,
      date: new Date("2020-09-19")
    },
    {
      id: 10702,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 9210,
      date: new Date("2020-09-09")
    },
    {
      id: 10703,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 3700,
      date: new Date("2020-09-01")
    },
    {
      id: 10704,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 3620,
      date: new Date("2020-09-19")
    },
    {
      id: 10705,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 4275,
      date: new Date("2020-09-01")
    },
    {
      id: 10706,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 2370,
      date: new Date("2020-09-03")
    },
    {
      id: 10707,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1870,
      date: new Date("2020-09-10")
    },
    {
      id: 10708,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 2070,
      date: new Date("2020-09-25")
    },
    {
      id: 10709,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 5025,
      date: new Date("2020-09-19")
    },
    {
      id: 10710,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 1080,
      date: new Date("2020-10-15")
    },
    {
      id: 10711,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 1400,
      date: new Date("2020-10-22")
    },
    {
      id: 10712,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 4260,
      date: new Date("2020-10-01")
    },
    {
      id: 10713,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 2745,
      date: new Date("2020-10-01")
    },
    {
      id: 10714,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 2920,
      date: new Date("2020-10-23")
    },
    {
      id: 10715,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 3520,
      date: new Date("2020-10-11")
    },
    {
      id: 10716,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 4035,
      date: new Date("2020-10-20")
    },
    {
      id: 10717,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 1730,
      date: new Date("2020-10-05")
    },
    {
      id: 10718,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 975,
      date: new Date("2020-10-06")
    },
    {
      id: 10719,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 5700,
      date: new Date("2020-10-06")
    },
    {
      id: 10720,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 5080,
      date: new Date("2020-10-18")
    },
    {
      id: 10721,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 2940,
      date: new Date("2020-10-24")
    },
    {
      id: 10722,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 2670,
      date: new Date("2020-10-04")
    },
    {
      id: 10723,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 1230,
      date: new Date("2020-10-11")
    },
    {
      id: 10724,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 600,
      date: new Date("2020-10-08")
    },
    {
      id: 10725,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 3700,
      date: new Date("2020-10-08")
    },
    {
      id: 10726,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 3375,
      date: new Date("2020-10-11")
    },
    {
      id: 10727,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 1500,
      date: new Date("2020-10-17")
    },
    {
      id: 10728,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 370,
      date: new Date("2020-10-05")
    },
    {
      id: 10729,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 2340,
      date: new Date("2020-10-16")
    },
    {
      id: 10730,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 1080,
      date: new Date("2020-10-08")
    },
    {
      id: 10731,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 2775,
      date: new Date("2020-10-21")
    },
    {
      id: 10732,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 4380,
      date: new Date("2020-11-09")
    },
    {
      id: 10733,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 5500,
      date: new Date("2020-11-21")
    },
    {
      id: 10734,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 1920,
      date: new Date("2020-11-24")
    },
    {
      id: 10735,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 765,
      date: new Date("2020-11-24")
    },
    {
      id: 10736,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 370,
      date: new Date("2020-11-18")
    },
    {
      id: 10737,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 3500,
      date: new Date("2020-11-25")
    },
    {
      id: 10738,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 825,
      date: new Date("2020-11-09")
    },
    {
      id: 10739,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 490,
      date: new Date("2020-11-23")
    },
    {
      id: 10740,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 7075,
      date: new Date("2020-11-20")
    },
    {
      id: 10741,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 1350,
      date: new Date("2020-11-25")
    },
    {
      id: 10742,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 1440,
      date: new Date("2020-11-15")
    },
    {
      id: 10743,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 2820,
      date: new Date("2020-11-13")
    },
    {
      id: 10744,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 2280,
      date: new Date("2020-11-12")
    },
    {
      id: 10745,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 1110,
      date: new Date("2020-11-03")
    },
    {
      id: 10746,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 1150,
      date: new Date("2020-11-23")
    },
    {
      id: 10747,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 2040,
      date: new Date("2020-11-20")
    },
    {
      id: 10748,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 3090,
      date: new Date("2020-11-24")
    },
    {
      id: 10749,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 1940,
      date: new Date("2020-11-24")
    },
    {
      id: 10750,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 3090,
      date: new Date("2020-11-16")
    },
    {
      id: 10751,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 4900,
      date: new Date("2020-11-05")
    },
    {
      id: 10752,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 3465,
      date: new Date("2020-11-07")
    },
    {
      id: 10753,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 1110,
      date: new Date("2020-11-20")
    },
    {
      id: 10754,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 1650,
      date: new Date("2020-11-02")
    },
    {
      id: 10755,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 5280,
      date: new Date("2020-12-04")
    },
    {
      id: 10756,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 3075,
      date: new Date("2020-12-02")
    },
    {
      id: 10757,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 690,
      date: new Date("2020-12-07")
    },
    {
      id: 10758,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 1305,
      date: new Date("2020-12-15")
    },
    {
      id: 10759,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 1970,
      date: new Date("2020-12-01")
    },
    {
      id: 10760,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 3760,
      date: new Date("2020-12-18")
    },
    {
      id: 10761,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 1920,
      date: new Date("2020-12-22")
    },
    {
      id: 10762,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 1360,
      date: new Date("2020-12-12")
    },
    {
      id: 10763,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 2525,
      date: new Date("2020-12-06")
    },
    {
      id: 10764,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 5575,
      date: new Date("2020-12-20")
    },
    {
      id: 10765,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 5560,
      date: new Date("2020-12-10")
    },
    {
      id: 10766,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 4880,
      date: new Date("2020-12-13")
    },
    {
      id: 10767,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 8850,
      date: new Date("2020-12-03")
    },
    {
      id: 10768,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 2820,
      date: new Date("2020-12-10")
    },
    {
      id: 10769,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 4000,
      date: new Date("2020-12-12")
    },
    {
      id: 10770,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 5820,
      date: new Date("2020-12-02")
    },
    {
      id: 10771,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 1275,
      date: new Date("2020-12-12")
    },
    {
      id: 10772,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 1310,
      date: new Date("2020-12-01")
    },
    {
      id: 10773,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 2180,
      date: new Date("2020-12-26")
    },
    {
      id: 10774,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 4470,
      date: new Date("2020-12-17")
    },
    {
      id: 10775,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 2990,
      date: new Date("2020-12-15")
    },
    {
      id: 10776,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 7650,
      date: new Date("2020-12-18")
    },
    {
      id: 10777,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 780,
      date: new Date("2020-12-02")
    },
    {
      id: 10778,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 2970,
      date: new Date("2020-12-13")
    },
    {
      id: 10779,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 1155,
      date: new Date("2020-12-05")
    },
    {
      id: 10780,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 4470,
      date: new Date("2021-01-10")
    },
    {
      id: 10781,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 1125,
      date: new Date("2021-01-21")
    },
    {
      id: 10782,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 645,
      date: new Date("2021-01-17")
    },
    {
      id: 10783,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 675,
      date: new Date("2021-01-05")
    },
    {
      id: 10784,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 2840,
      date: new Date("2021-01-05")
    },
    {
      id: 10785,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 2660,
      date: new Date("2021-01-04")
    },
    {
      id: 10786,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 4560,
      date: new Date("2021-01-12")
    },
    {
      id: 10787,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 2880,
      date: new Date("2021-01-20")
    },
    {
      id: 10788,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 500,
      date: new Date("2021-01-02")
    },
    {
      id: 10789,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 3925,
      date: new Date("2021-01-07")
    },
    {
      id: 10790,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 5660,
      date: new Date("2021-01-18")
    },
    {
      id: 10791,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 1460,
      date: new Date("2021-01-22")
    },
    {
      id: 10792,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 5040,
      date: new Date("2021-01-10")
    },
    {
      id: 10793,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 4830,
      date: new Date("2021-01-13")
    },
    {
      id: 10794,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 3075,
      date: new Date("2021-01-22")
    },
    {
      id: 10795,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 3120,
      date: new Date("2021-01-14")
    },
    {
      id: 10796,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 3525,
      date: new Date("2021-01-23")
    },
    {
      id: 10797,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 1930,
      date: new Date("2021-01-09")
    },
    {
      id: 10798,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 2890,
      date: new Date("2021-01-02")
    },
    {
      id: 10799,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 1545,
      date: new Date("2021-01-17")
    },
    {
      id: 10800,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 3630,
      date: new Date("2021-01-20")
    },
    {
      id: 10801,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 4035,
      date: new Date("2021-01-14")
    },
    {
      id: 10802,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 345,
      date: new Date("2021-01-06")
    },
    {
      id: 10803,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 7000,
      date: new Date("2021-01-07")
    },
    {
      id: 10804,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 3060,
      date: new Date("2021-02-13")
    },
    {
      id: 10805,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 6425,
      date: new Date("2021-02-04")
    },
    {
      id: 10806,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 615,
      date: new Date("2021-02-22")
    },
    {
      id: 10807,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 1755,
      date: new Date("2021-02-07")
    },
    {
      id: 10808,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 1540,
      date: new Date("2021-02-21")
    },
    {
      id: 10809,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 2820,
      date: new Date("2021-02-24")
    },
    {
      id: 10810,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 4305,
      date: new Date("2021-02-10")
    },
    {
      id: 10811,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 1520,
      date: new Date("2021-02-26")
    },
    {
      id: 10812,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 4725,
      date: new Date("2021-02-18")
    },
    {
      id: 10813,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 6750,
      date: new Date("2021-02-16")
    },
    {
      id: 10814,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 5540,
      date: new Date("2021-02-07")
    },
    {
      id: 10815,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 1880,
      date: new Date("2021-02-24")
    },
    {
      id: 10816,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 6180,
      date: new Date("2021-02-26")
    },
    {
      id: 10817,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 9300,
      date: new Date("2021-02-03")
    },
    {
      id: 10818,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 3700,
      date: new Date("2021-02-26")
    },
    {
      id: 10819,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 740,
      date: new Date("2021-02-01")
    },
    {
      id: 10820,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 4755,
      date: new Date("2021-02-23")
    },
    {
      id: 10821,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 2570,
      date: new Date("2021-02-20")
    },
    {
      id: 10822,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 2860,
      date: new Date("2021-02-19")
    },
    {
      id: 10823,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 5430,
      date: new Date("2021-03-21")
    },
    {
      id: 10824,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 4525,
      date: new Date("2021-03-21")
    },
    {
      id: 10825,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 1515,
      date: new Date("2021-03-10")
    },
    {
      id: 10826,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 630,
      date: new Date("2021-03-15")
    },
    {
      id: 10827,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 1310,
      date: new Date("2021-03-01")
    },
    {
      id: 10828,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 3200,
      date: new Date("2021-03-17")
    },
    {
      id: 10829,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 3945,
      date: new Date("2021-03-20")
    },
    {
      id: 10830,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 2990,
      date: new Date("2021-03-18")
    },
    {
      id: 10831,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 1125,
      date: new Date("2021-03-22")
    },
    {
      id: 10832,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 7950,
      date: new Date("2021-03-17")
    },
    {
      id: 10833,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 2960,
      date: new Date("2021-03-25")
    },
    {
      id: 10834,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 6300,
      date: new Date("2021-03-20")
    },
    {
      id: 10835,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 8670,
      date: new Date("2021-03-07")
    },
    {
      id: 10836,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 3930,
      date: new Date("2021-03-23")
    },
    {
      id: 10837,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 6975,
      date: new Date("2021-03-02")
    },
    {
      id: 10838,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 4220,
      date: new Date("2021-03-17")
    },
    {
      id: 10839,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 3090,
      date: new Date("2021-03-25")
    },
    {
      id: 10840,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 2380,
      date: new Date("2021-03-01")
    },
    {
      id: 10841,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1510,
      date: new Date("2021-03-07")
    },
    {
      id: 10842,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 1020,
      date: new Date("2021-03-19")
    },
    {
      id: 10843,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 6700,
      date: new Date("2021-03-26")
    },
    {
      id: 10844,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 4890,
      date: new Date("2021-04-02")
    },
    {
      id: 10845,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 7225,
      date: new Date("2021-04-13")
    },
    {
      id: 10846,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 795,
      date: new Date("2021-04-07")
    },
    {
      id: 10847,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 1785,
      date: new Date("2021-04-03")
    },
    {
      id: 10848,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 1850,
      date: new Date("2021-04-03")
    },
    {
      id: 10849,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 5120,
      date: new Date("2021-04-12")
    },
    {
      id: 10850,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 615,
      date: new Date("2021-04-07")
    },
    {
      id: 10851,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 2860,
      date: new Date("2021-04-05")
    },
    {
      id: 10852,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 1525,
      date: new Date("2021-04-24")
    },
    {
      id: 10853,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 7425,
      date: new Date("2021-04-15")
    },
    {
      id: 10854,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 6080,
      date: new Date("2021-04-13")
    },
    {
      id: 10855,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 2940,
      date: new Date("2021-04-04")
    },
    {
      id: 10856,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 5580,
      date: new Date("2021-04-16")
    },
    {
      id: 10857,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 9390,
      date: new Date("2021-04-19")
    },
    {
      id: 10858,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 3200,
      date: new Date("2021-04-26")
    },
    {
      id: 10859,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 4380,
      date: new Date("2021-04-05")
    },
    {
      id: 10860,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 4725,
      date: new Date("2021-04-06")
    },
    {
      id: 10861,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 930,
      date: new Date("2021-04-25")
    },
    {
      id: 10862,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 1910,
      date: new Date("2021-04-05")
    },
    {
      id: 10863,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 2725,
      date: new Date("2021-04-16")
    },
    {
      id: 10864,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 4720,
      date: new Date("2021-04-02")
    },
    {
      id: 10865,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 5190,
      date: new Date("2021-04-10")
    },
    {
      id: 10866,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 2800,
      date: new Date("2021-04-26")
    },
    {
      id: 10867,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 3780,
      date: new Date("2021-04-24")
    },
    {
      id: 10868,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 2340,
      date: new Date("2021-04-17")
    },
    {
      id: 10869,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Kelly Rodriquez",
      amount: 4830,
      date: new Date("2021-05-12")
    },
    {
      id: 10870,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Walter Hobbs",
      amount: 2075,
      date: new Date("2021-05-23")
    },
    {
      id: 10871,
      salon: "Wilson",
      country: "United States of America",
      stylist: "Robert Reagan",
      amount: 3420,
      date: new Date("2021-05-21")
    },
    {
      id: 10872,
      salon: "Wilson",
      country: "Canada",
      stylist: "Robert Reagan",
      amount: 1440,
      date: new Date("2021-05-10")
    },
    {
      id: 10873,
      salon: "Wilson",
      country: "Canada",
      stylist: "Greta Sims",
      amount: 1680,
      date: new Date("2021-05-15")
    },
    {
      id: 10874,
      salon: "Commerce",
      country: "Brazil",
      stylist: "Olivia Peyton",
      amount: 3440,
      date: new Date("2021-05-16")
    },
    {
      id: 10875,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 4695,
      date: new Date("2021-05-10")
    },
    {
      id: 10876,
      salon: "Commerce",
      country: "Paraguay",
      stylist: "Asuncion",
      amount: 2380,
      date: new Date("2021-05-06")
    },
    {
      id: 10877,
      salon: "Fair Lakes",
      country: "United Kingdom",
      stylist: "Brett Wade",
      amount: 1875,
      date: new Date("2021-05-25")
    },
    {
      id: 10878,
      salon: "Fair Lakes",
      country: "Germany",
      stylist: "Sam Hill",
      amount: 7550,
      date: new Date("2021-05-14")
    },
    {
      id: 10879,
      salon: "Fair Lakes",
      country: "Spain",
      stylist: "Greta Sims",
      amount: 3340,
      date: new Date("2021-05-01")
    },
    {
      id: 10880,
      salon: "Fair Lakes",
      country: "Russian Federation",
      stylist: "Brett Wade",
      amount: 1400,
      date: new Date("2021-05-22")
    },
    {
      id: 10881,
      salon: "Lee Hwy",
      country: "China",
      stylist: "Sandra Johnson",
      amount: 6060,
      date: new Date("2021-05-22")
    },
    {
      id: 10882,
      salon: "Lee Hwy",
      country: "Japan",
      stylist: "Olivia Peyton",
      amount: 8370,
      date: new Date("2021-05-13")
    },
    {
      id: 10883,
      salon: "Lee Hwy",
      country: "Republic of Korea",
      stylist: "Kevin Carter",
      amount: 3550,
      date: new Date("2021-05-26")
    },
    {
      id: 10884,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Cyntia Stanwick",
      amount: 2620,
      date: new Date("2021-05-17")
    },
    {
      id: 10885,
      salon: "Lee Hwy",
      country: "Lee Hwy",
      stylist: "Kent Samuelson",
      amount: 2400,
      date: new Date("2021-05-21")
    },
    {
      id: 10886,
      salon: "Commerce",
      country: "South Commerce",
      stylist: "Cynthia Stanwick",
      amount: 1740,
      date: new Date("2021-05-21")
    },
    {
      id: 10887,
      salon: "Commerce",
      country: "Egypt",
      stylist: "Taylor Riley",
      amount: 500,
      date: new Date("2021-05-26")
    },
    {
      id: 10888,
      salon: "Commerce",
      country: "Argentina",
      stylist: "Walter Hobbs",
      amount: 780,
      date: new Date("2021-05-07")
    }
  ];
  